import {
    BaselineData,
    CustomSeriesPricePlotValues,
    ISeriesApi,
    PaneRendererCustomData,
    Time,
    WhitespaceData
} from 'lightweight-charts'
import { defaultOptions, BaselineSeriesOptions } from './options'
import { BaseLineSeriesRenderer } from './renderer'
import { ISeriesPaneView } from '../customSeries.typings.ts'
import Chart from '../../chart'


export class BaseLineSeries<TData extends BaselineData>
    implements ISeriesPaneView<Time, TData, BaselineSeriesOptions> {
    _renderer: BaseLineSeriesRenderer<TData>

    chart: Chart

    constructor(chart: Chart) {
        this.chart = chart
        this._renderer = new BaseLineSeriesRenderer(chart)
    }

    priceValueBuilder(plotRow: TData): CustomSeriesPricePlotValues {
        return [plotRow.value]
    }

    isWhitespace(data: TData | WhitespaceData): data is WhitespaceData {
        return (data as Partial<TData>).value === undefined
    }

    renderer(): BaseLineSeriesRenderer<TData> {
        return this._renderer
    }

    update(
        data: PaneRendererCustomData<Time, TData>,
        options: BaselineSeriesOptions
    ): void {
        this._renderer.update(data, options)
    }

    defaultOptions() {
        return defaultOptions
    }

    setSeriesApi(api: ISeriesApi<'Custom', Time, TData>) {
        this._renderer.setSeriesApi(api)
    }
}
